<div class="input-group">
  <input
    [attr.aria-labelledby]="labelId"
    class="form-control"
    placeholder="mm/dd/yyyy"
    ngbDatepicker
    [firstDayOfWeek]="7"
    (blur)="onBlur()"
  />
  <button type="button" class="p-0 border-0 rounded-end" (click)="toggleDatePicker()" [disabled]="disabled" title="calendar">
    <span class="input-group-text d-block">
      <i class="far fa-calendar-alt"></i>
    </span>
  </button>
</div>
